import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import EmbedContext, { isEmbedAllowedPath } from "../context/Embed";

// In embed mode, any route outside the pinned restaurant's order flow
// bounces back to that restaurant's page. Wraps <Routes> so disallowed
// screens never mount.
function EmbedGuard({ children }) {
  const { isEmbed, embedSlug } = useContext(EmbedContext);
  const location = useLocation();

  if (!isEmbed || isEmbedAllowedPath(location.pathname, embedSlug)) {
    return children;
  }
  return <Navigate to={`/restaurant/${embedSlug}`} replace />;
}

export default EmbedGuard;
